<script lang="ts">
	import { trackEvent } from "@utils/trackEvent.js";
	import "ckeditor5/ckeditor5-content.css";
	import clsx from "clsx";
	import { onMount } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import { transformCkEditorContent } from "@core/utils/transformCkEditorContent.js";

	const {
		html,
		class: customClass,
		lightboxId = "content",
	}: {
		html: string;
		class?: ClassValue;
		lightboxId?: string;
	} = $props();

	// Styled CTA blocks are raw HTML (htmlEmbed), so there's no per-link handler to
	// attach — delegate one click listener and match the CTA classes instead.
	const ctaSelector = ".ckeditor-content a.fst-cta-pill, .ckeditor-content a.fst-cta-link";

	onMount(() => {
		function handleCtaClick(event: MouseEvent): void {
			if (!(event.target instanceof Element)) {
				return;
			}

			const cta = event.target.closest(ctaSelector);
			if (!(cta instanceof HTMLAnchorElement)) {
				return;
			}

			trackEvent("cta_klik", {
				link_text: cta.textContent?.trim().slice(0, 100) ?? "",
				link_url: cta.getAttribute("href") ?? "",
				article: window.location.pathname,
			});
		}

		document.addEventListener("click", handleCtaClick, { capture: true });
		return () => {
			document.removeEventListener("click", handleCtaClick, { capture: true });
		};
	});

	/* eslint-disable svelte/no-at-html-tags */
</script>

{@html transformCkEditorContent(html, { customClass: clsx(customClass), lightboxId })}
